import * as AnalysisAndQuery from './analysisAndQuery';
import * as Kardex from './kardex';
import * as CodesWithoutLabels from './codesWithoutLabels';

const reducers = {
  ...AnalysisAndQuery,
  ...Kardex,
  ...CodesWithoutLabels,
};

export default reducers;
